<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
import {GetColumnChartDataGroupByClassifyAndWeek} from '../../../../api/oa'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 2000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '330px'
    }
  },
  data() {
    return {
      chart: null,
      listone: [],
      listtwo: [],
      listthree: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
    var user = JSON.parse(window.localStorage.user);
    GetColumnChartDataGroupByClassifyAndWeek({userCode: user.sub}).then(res => {
      this.listone = res.data.response[0];
      this.listtwo = res.data.response[1];
      this.listthree = res.data.response[2];
       this.initChart();
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周天'],
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          }
        }],
        series: [{
          name: '日常任务',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: this.listone,
          animationDuration
        }, {
          name: '专项会议',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: this.listtwo,
          animationDuration
        }, {
          name: '例会项目',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: this.listthree,
          animationDuration
        }]
      })
    }
  }
}
</script>
